export interface Notification {
  id: number;
  from_user_id: number;
  notification_id: number;
  is_read: boolean;
  message: string;
}

export enum NotificationState {
  Accepted = 2,
  Declined = 31,
}


export enum userType {
  Professional = 'Professional',
  ProfessionalUserRelationShip = "ProfessionalUserRelationShip"
}
